import script from "./ApprovalListTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalListTable.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalListTable.vue?vue&type=style&index=0&id=b9d72124&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9d72124"]])

export default __exports__